var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequistion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0375 0H12C10.3638 0 9.03754 1.32385 9.03754 2.96246V16.5187C9.03754 17.0938 9.69708 17.4302 10.1625 17.0812L12.9875 14.9625H21.0375C22.6738 14.9625 24 13.6386 24 12V2.96246C24 1.32623 22.6761 0 21.0375 0V0ZM15.8156 11.1969H12.7531C12.3647 11.1969 12.05 10.8821 12.05 10.4938C12.05 10.1054 12.3647 9.79065 12.7531 9.79065H15.8156C16.2039 9.79065 16.5187 10.1054 16.5187 10.4938C16.5187 10.8821 16.2039 11.1969 15.8156 11.1969ZM20.2844 8.18445H12.7531C12.3647 8.18445 12.05 7.86951 12.05 7.48132C12.05 7.09296 12.3647 6.7782 12.7531 6.7782H20.2844C20.6726 6.7782 20.9875 7.09296 20.9875 7.48132C20.9875 7.86951 20.6728 8.18445 20.2844 8.18445ZM20.2844 5.17181H12.7531C12.3647 5.17181 12.05 4.85706 12.05 4.46869C12.05 4.08051 12.3647 3.76556 12.7531 3.76556H20.2844C20.6726 3.76556 20.9875 4.08051 20.9875 4.46869C20.9875 4.85706 20.6728 5.17181 20.2844 5.17181Z",
    fill: "#737A91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79242 14.6208C7.79242 16.4564 6.30432 17.9445 4.46869 17.9445C2.63306 17.9445 1.14496 16.4564 1.14496 14.6208C1.14496 12.785 2.63306 11.2969 4.46869 11.2969C6.30432 11.2969 7.79242 12.785 7.79242 14.6208Z",
    fill: "#737A91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.46869 17.9453C2.00079 17.9453 0 19.9461 0 22.414V23.2982C0 23.6866 0.314758 24.0013 0.703125 24.0013H8.23444C8.62262 24.0013 8.93756 23.6866 8.93756 23.2982V22.414C8.93756 19.9461 6.93677 17.9453 4.46869 17.9453Z",
    fill: "#737A91"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequistion);
export default __webpack_public_path__ + "static/media/requistion.bb0f8bd3.svg";
export { ForwardRef as ReactComponent };